import api from './api';

export const purchaseOrderService = {
  /**
   * Obtener todas las órdenes de compra
   */
  async getPurchaseOrders(params = {}) {
    try {
      console.log('📡 [purchaseOrderService] Enviando petición GET a:', '/api/purchase-orders');
      console.log('📋 [purchaseOrderService] Parámetros:', params);
      console.log('🔗 [purchaseOrderService] URL completa:', `/api/purchase-orders?${new URLSearchParams(params).toString()}`);
      
      const response = await api.get('/purchase-orders', { params });
      
      console.log('✅ [purchaseOrderService] Respuesta recibida exitosamente');
      console.log('📦 [purchaseOrderService] Response.data:', response.data);
      console.log('🔢 [purchaseOrderService] Cantidad de órdenes:', Array.isArray(response.data?.data) ? response.data.data.length : 'No es un array');
      console.log('📊 [purchaseOrderService] response.data.success:', response.data?.success);
      
      return response.data;
    } catch (error) {
      console.error('❌ [purchaseOrderService] Error al obtener órdenes de compra:', error);
      console.error('📊 [purchaseOrderService] Error.response:', error.response);
      console.error('📋 [purchaseOrderService] Error.response?.data:', error.response?.data);
      console.error('🔢 [purchaseOrderService] Error.response?.status:', error.response?.status);
      throw error;
    }
  },

  /**
   * Obtener una orden de compra por ID
   */
  async getPurchaseOrder(id) {
    try {
      const response = await api.get(`/purchase-orders/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener orden de compra:', error);
      throw error;
    }
  },

  /**
   * Crear una nueva orden de compra
   */
  async createPurchaseOrder(orderData) {
    try {
      console.log('📡 [purchaseOrderService] Enviando petición POST a:', '/api/purchase-orders');
      console.log('📋 [purchaseOrderService] Datos de la orden:', orderData);
      console.log('📊 [purchaseOrderService] Cantidad de items:', orderData.items?.length || 0);
      
      const response = await api.post('/purchase-orders', orderData);
      
      console.log('✅ [purchaseOrderService] Orden de compra creada exitosamente');
      console.log('📦 [purchaseOrderService] Response.data:', response.data);
      console.log('🆔 [purchaseOrderService] ID de orden creada:', response.data?.data?.id);
      console.log('🔖 [purchaseOrderService] Código de orden:', response.data?.data?.code);
      
      return response.data;
    } catch (error) {
      console.error('❌ [purchaseOrderService] Error al crear orden de compra:', error);
      console.error('📊 [purchaseOrderService] Error.response:', error.response);
      console.error('📋 [purchaseOrderService] Error.response?.data:', error.response?.data);
      throw error;
    }
  },

  /**
   * Actualizar una orden de compra
   */
  async updatePurchaseOrder(id, orderData) {
    try {
      console.log('📡 [purchaseOrderService] Enviando petición PUT a:', `/api/purchase-orders/${id}`);
      console.log('🆔 [purchaseOrderService] ID de orden:', id);
      console.log('📋 [purchaseOrderService] Datos de la orden:', orderData);
      
      const response = await api.put(`/purchase-orders/${id}`, orderData);
      
      console.log('✅ [purchaseOrderService] Orden de compra actualizada exitosamente');
      console.log('📦 [purchaseOrderService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [purchaseOrderService] Error al actualizar orden de compra:', error);
      console.error('📊 [purchaseOrderService] Error.response:', error.response);
      throw error;
    }
  },

  /**
   * Cerrar OC como completada (documento distinto o recepción final con diferencias).
   */
  async closeFulfillment(id, { notes = null, document_id = null } = {}) {
    try {
      const response = await api.patch(`/purchase-orders/${id}/close-fulfillment`, {
        notes,
        document_id,
      });
      return response.data;
    } catch (error) {
      console.error('Error al cerrar orden de compra:', error);
      throw error;
    }
  },

  /** Reabre una OC cerrada manualmente (restaura avance parcial/emitida). */
  async reopenFulfillment(id) {
    try {
      const response = await api.patch(`/purchase-orders/${id}/reopen-fulfillment`);
      return response.data;
    } catch (error) {
      console.error('Error al reabrir orden de compra:', error);
      throw error;
    }
  },

  /**
   * Cancelar o reactivar una orden de compra (toggle)
   */
  async togglePurchaseOrderStatus(id) {
    try {
      console.log('📡 [purchaseOrderService] Enviando petición DELETE a:', `/api/purchase-orders/${id}`);
      console.log('🆔 [purchaseOrderService] ID de orden a cambiar estado:', id);
      
      const response = await api.delete(`/purchase-orders/${id}`);
      
      console.log('✅ [purchaseOrderService] Estado de orden cambiado exitosamente');
      console.log('📦 [purchaseOrderService] Response.data:', response.data);
      
      return response.data;
    } catch (error) {
      console.error('❌ [purchaseOrderService] Error al cambiar estado de orden:', error);
      console.error('📊 [purchaseOrderService] Error.response:', error.response);
      throw error;
    }
  },

  /**
   * Obtener todos los datos del formulario de orden de compra en una sola petición.
   * Incluye: proveedores, productos, unidades y proyectos.
   */
  async getFormData() {
    try {
      const response = await api.get('/purchase-orders/form-data');
      return response.data;
    } catch (error) {
      console.error('Error al obtener datos del formulario de orden de compra:', error);
      throw error;
    }
  },

  /**
   * Obtener productos (para el formulario)
   * Nota: Este método se mantiene por compatibilidad, pero ahora los productos
   * se obtienen junto con los proveedores usando with_products=true
   */
  async getProducts() {
    try {
      const response = await api.get('/products', { params: { active_only: true } });
      return response.data;
    } catch (error) {
      console.error('Error al obtener productos:', error);
      throw error;
    }
  },
};
